<template>
    <div class="flex items-center">
        <div class="flex items-center relative">
            <icon
                :name="$icons.loading"
                class="link-grey | h-5 w-5 | xl:h-4 xl:w-4"
                :class="{ 'spin-inverse': loading }"
                @click="$emit('click')"
            />
            <div class="badge badge-warning | absolute top-0 left-0 ml-2 -mt-1" v-if="showBadge" />
        </div>
        <div class="text-grey-500 ml-2" v-if="showLoadingPercent">
            {{ loadingPercent }}%
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ActivixReload',

        props: {
            loading: {
                type: Boolean,
                default: false,
            },
            loadingPercent: {
                type: Number,
                default: null,
            },
            showBadge: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            showLoadingPercent() {
                return this.loading && this.loadingPercent !== null;
            },
        },
    };
</script>
